'use client'
import LayoutModal, { LayoutModalProps } from '@components/popup/layout-modal'

import Footer from './footer'
import Form from './form'

import styles from './menu.module.scss'

import MenuLinks from './menu-links'

import type { JSX } from 'react'

export default function Menu({ isOpen, close }: Omit<LayoutModalProps, 'children' | 'title'>): JSX.Element {
  return (
    <LayoutModal isOpen={isOpen} close={close} title={<h2 className={styles.title}>Menu</h2>}>
      <MenuLinks close={close} />
      <Form close={close} />
      <Footer />
    </LayoutModal>
  )
}
